import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4fd18e86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "content w-full bg-white" }
const _hoisted_3 = { class: "t-test-detail" }
const _hoisted_4 = { class: "t-test-detail__content" }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = { class: "t-test-detail__content-image justify-content-center align-items-center" }
const _hoisted_7 = {
  key: 0,
  class: "animate-pulse"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-56 w-56 bg-gray-200 rounded-full" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "t-test-detail__content-wrapper d-flex flex-column" }
const _hoisted_12 = { class: "t-test-detail__content-header flex flex-column justify-content-start" }
const _hoisted_13 = { class: "w-full flex flex-col md:flex-row justify-between items-end md:items-center" }
const _hoisted_14 = {
  key: 0,
  class: "w-1/2 animate-pulse"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-14 bg-gray-200 rounded-md" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "text-primary-gc text-2.5xl font-semibold md:mb-0 mb-3"
}
const _hoisted_18 = { class: "flex" }
const _hoisted_19 = { class: "flex flex-column" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-dark-gray-gc text-xs m-0" }, "Jumlah Pertanyaan", -1))
const _hoisted_21 = {
  key: 0,
  class: "w-full animate-pulse"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-9 bg-gray-200 rounded-md" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 1,
  class: "text-primary-gc text-base font-semibold m-0"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-3" }, null, -1))
const _hoisted_26 = {
  key: 0,
  class: "animate-pulse"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-5 w-4/5 bg-gray-200 rounded-md mb-1" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-5 w-3/5 bg-gray-200 rounded-md mb-1" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-5 w-2/5 bg-gray-200 rounded-md" }, null, -1))
const _hoisted_30 = [
  _hoisted_27,
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = { class: "t-test-detail__content-detail d-flex flex-column mt-4" }
const _hoisted_33 = { class: "t-test-detail__content-detail-wrapper d-flex" }
const _hoisted_34 = { class: "d-flex flex-column w-full" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-primary-gc text-xl font-semibold mb-3" }, " Cara Mengerjakan ", -1))
const _hoisted_36 = {
  key: 0,
  class: "animate-pulse"
}
const _hoisted_37 = /*#__PURE__*/_createStaticVNode("<div class=\"h-5 w-full bg-gray-200 rounded-md mt-1 mb-1\" data-v-4fd18e86></div><div class=\"h-5 w-full bg-gray-200 rounded-md mb-1\" data-v-4fd18e86></div><div class=\"h-5 w-full bg-gray-200 rounded-md mb-1\" data-v-4fd18e86></div><div class=\"h-5 w-full bg-gray-200 rounded-md mb-1\" data-v-4fd18e86></div><div class=\"h-5 w-full bg-gray-200 rounded-md\" data-v-4fd18e86></div>", 5)
const _hoisted_42 = [
  _hoisted_37
]
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = { class: "t-test-detail__footer d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GcHeader = _resolveComponent("GcHeader")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_BButton = _resolveComponent("BButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_GcHeader, { "profile-data": _ctx.profileData }, null, 8, ["profile-data"])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _ctx.detailTest.image
                }, null, 8, _hoisted_10))
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("p", {
                class: "text-primary-gc text-sm font-semibold mb-3 cursor-pointer",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('/home')))
              }, [
                _createVNode(_component_FontAwesomeIcon, {
                  class: "text-warning-text-gc mr-2",
                  icon: "chevron-left"
                }),
                _createTextVNode(" Kembali ")
              ]),
              _createElementVNode("div", _hoisted_13, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
                  : (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.detailTest.name), 1)),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_FontAwesomeIcon, {
                    class: "text-primary-gc text-2xl mr-2",
                    icon: "pen-to-square"
                  }),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    (_ctx.isLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
                      : (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_ctx.detailTest.total_question) + " Pertanyaan ", 1))
                  ])
                ])
              ])
            ]),
            _hoisted_25,
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_30))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "text-sm text-justify",
                  innerHTML: _ctx.detailTest.description
                }, null, 8, _hoisted_31)),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  (_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_42))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "text-sm",
                        innerHTML: _ctx.detailTest.instructions
                      }, null, 8, _hoisted_43))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_44, [
          _createVNode(_component_BButton, {
            variant: "warning",
            class: "t-test-detail__footer-action text-center md:text-left text-sm font-semibold mt-4 py-2 md:px-8",
            onClick: _ctx.startTest
          }, {
            default: _withCtx(() => [
              (_ctx.detailTest.total_example > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("Ayo Latihan")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("Mulai Tes")
                  ], 64)),
              _createVNode(_component_FontAwesomeIcon, {
                class: "ml-2",
                icon: "chevron-right"
              })
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ])
  ], 64))
}